import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PendingLinksState } from './pending-links.reducer';

export const selectPendingLinksState =
  createFeatureSelector<PendingLinksState>('pendingLinks');

export const selectPendingLinks = createSelector(
  selectPendingLinksState,
  (state) => state.pendingLinks
);

export const selectPendingLinksMeta = createSelector(
  selectPendingLinksState,
  (state) => state.meta
);

export const selectPendingLinksLoading = createSelector(
  selectPendingLinksState,
  (state) => state.isLoading
);

export const selectPendingLinksDeciding = createSelector(
  selectPendingLinksState,
  (state) => state.isDeciding
);

export const selectPendingLinksExporting = createSelector(
  selectPendingLinksState,
  (state) => state.isExporting
);

export const selectPendingLinksError = createSelector(
  selectPendingLinksState,
  (state) => state.error
);

export const selectPendingLinksExportMessage = createSelector(
  selectPendingLinksState,
  (state) => state.exportMessage
);

export const selectPendingLinksLastQuery = createSelector(
  selectPendingLinksState,
  (state) => state.lastQuery
);
